<template>
    <div class="banner-container">
      <v-img
        :src="require('../assets/Images/wti-banner.jpg')"
        :height="getBannerHeight"
        class="banner-image"
        cover
      >
        <v-container  fill-height>
          <v-row align="center" justify="center">
            <v-col cols="12" class="text-center">
              <h1 
                class="banner-title oswaldbold white--text"
                :class="responsiveTitleClass"
              >
              WILD BYTES
              </h1>
            </v-col>
          </v-row>
        </v-container>
      </v-img>
    </div>
  </template>
  
  <script>
  export default {
    computed: {
      getBannerHeight() {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return '500px'
          case 'sm': return '500px'
          case 'md': return '500px'
          case 'lg': return '500px'
          case 'xl': return '600px'
          default: return '400px'
        }
      },
      responsiveTitleClass() {
        return {
          'text-h2': this.$vuetify.breakpoint.xs,
          'text-h1': this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md,
          'display-2': this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .banner-container {
    width: 100%;
  }
  
  .banner-image {
    width: 100%;
  }
  
  .banner-title {
    text-transform: uppercase;
    letter-spacing: 2px;
  }
  
  /* Custom breakpoint styles */
  @media (max-width: 600px) {
    .banner-title {
      font-size: 2rem !important;
      font-weight: bold;
      letter-spacing: 1px;
    }
  }
  
  @media (min-width: 601px) and (max-width: 960px) {
    .banner-title {
      font-size: 3rem !important;
      font-weight: bold;
    }
  }
  
  @media (min-width: 961px) and (max-width: 1264px) {
    .banner-title {
      font-size: 4rem !important;
      font-weight: bold;
    }
  }
  
  @media (min-width: 1265px) {
    .banner-title {
      font-size: 5rem !important;
      font-weight: bold;
    }
  }
  </style>